exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".readingLevelContainer{display:inline-block;margin-left:10px}.readingLevelContainer .verticalDivider{border-color:#bbb;height:20px;padding-right:10px}.readingLevelContainer .readingLevelImg{width:15px;margin-left:5px}.contentItems .readingLevelContainer{margin-bottom:5px}.contentItems .readingLevelContainer .readingLevelImg{margin-left:5px}.readingLevelDisplay{margin-right:.4em}.readingLevelDisplay .level{width:30px;display:inline-block}.readingLevelDisplay .readingLevelContainer{position:absolute;margin-left:5px}.readingLevelDisplay .readingLevelContainer .readingLeveLImg{margin-left:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/reading_level_icon.scss
// module id = 1366
// module chunks = 0